import React, { useEffect, useRef, useState } from 'react';

const galleryImages = [
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20photo%20of%20elegant%20gala%20dinner%20event%20with%20round%20tables%20decorated%20with%20white%20flowers%20and%20candles%2C%20Bangladeshi%20and%20Italian%20businessmen%20in%20formal%20attire%20networking%20in%20warm%20candlelit%20banquet%20hall%2C%20soft%20golden%20ambient%20lighting%2C%20realistic%20event%20photography&width=800&height=600&seq=g1&orientation=landscape',
    caption: 'Annual Gala Dinner 2025',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Professional%20trade%20fair%20exhibition%20hall%20with%20Italian%20food%20products%20displayed%20on%20modern%20white%20booth%20stands%2C%20visitors%20walking%20through%20bright%20exhibition%20center%20in%20Dhaka%20Bangladesh%2C%20warm%20lighting%2C%20realistic%20event%20photography&width=800&height=600&seq=g2&orientation=landscape',
    caption: 'Italian Food & Agri Expo',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Large%20conference%20room%20with%20business%20delegates%20from%20Bangladesh%20and%20Italy%20seated%20in%20modern%20auditorium%2C%20speaker%20at%20podium%20with%20Italian%20flag%20visible%2C%20warm%20professional%20conference%20photography%2C%20realistic%20corporate%20event&width=800&height=600&seq=g3&orientation=landscape',
    caption: 'Bilateral Business Forum',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Outdoor%20cultural%20performance%20event%20at%20sunset%20with%20Bangladeshi%20folk%20dancers%20and%20Italian%20performers%20on%20decorated%20stage%2C%20audience%20seated%20in%20elegant%20garden%20setting%2C%20warm%20golden%20hour%20lighting%2C%20realistic%20event%20photography&width=800&height=600&seq=g4&orientation=landscape',
    caption: 'Cultural Exchange Evening',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Business%20delegation%20group%20photo%20on%20steps%20of%20elegant%20Italian%20building%20in%20Rome%2C%20Bangladeshi%20businessmen%20in%20suits%20with%20Italian%20hosts%2C%20warm%20Mediterranean%20lighting%2C%20professional%20group%20portrait%20photography%2C%20realistic&width=800&height=600&seq=g5&orientation=landscape',
    caption: 'Trade Mission to Rome 2025',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Modern%20startup%20workshop%20room%20with%20young%20Bangladeshi%20entrepreneurs%20around%20large%20table%20with%20laptops%20and%20presentation%20screen%20showing%20Italian%20design%20concepts%2C%20bright%20modern%20co-working%20space%2C%20realistic%20photography&width=800&height=600&seq=g6&orientation=landscape',
    caption: 'Youth Bootcamp',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Formal%20signing%20ceremony%20between%20Bangladesh%20and%20Italy%20business%20representatives%20at%20long%20conference%20table%20with%20microphones%20and%20flags%2C%20shaking%20hands%20over%20signed%20documents%2C%20warm%20professional%20lighting%2C%20realistic%20corporate%20photography&width=800&height=600&seq=g7&orientation=landscape',
    caption: 'MoU Signing Ceremony',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Elegant%20networking%20reception%20with%20Bangladeshi%20and%20Italian%20professionals%20holding%20wine%20glasses%20and%20conversing%20in%20upscale%20hotel%20lobby%20with%20marble%20floors%20and%20chandeliers%2C%20warm%20ambient%20lighting%2C%20realistic%20event%20photography&width=800&height=600&seq=g8&orientation=landscape',
    caption: 'Networking Reception',
  },
];

// --- Shared Reveal Logic ---
function useReveal() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.querySelectorAll<HTMLElement>('[data-r]').forEach((node, i) => {
            setTimeout(() => {
              node.style.opacity = '1';
              node.style.transform = 'translateY(0) translateX(0)';
            }, i * 120);
          });
          obs.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

const hide = (dir: 'up' | 'left' | 'right' = 'up'): React.CSSProperties => ({
  opacity: 0,
  transform:
    dir === 'up' ? 'translateY(28px)'
    : dir === 'left' ? 'translateX(-32px)'
    : 'translateX(32px)',
  transition: 'opacity 0.8s ease, transform 0.8s ease',
});
// ---------------------------

export default function GallerySection() {
  const sectionRef = useReveal();
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const openLightbox = (index: number) => {
    setActiveIndex(index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setActiveIndex(null);
    document.body.style.overflow = '';
  };

  const prevImage = () => {
    if (activeIndex !== null) {
      setActiveIndex(activeIndex === 0 ? galleryImages.length - 1 : activeIndex - 1);
    }
  };

  const nextImage = () => {
    if (activeIndex !== null) {
      setActiveIndex(activeIndex === galleryImages.length - 1 ? 0 : activeIndex + 1);
    }
  };

  return (
    <section id="gallery" className="py-20 md:py-24 font-sans" style={{ backgroundColor: '#F8F7F3' }}>
      <div ref={sectionRef} className="w-full px-6 md:px-10 lg:px-16 xl:px-24 max-w-[1400px] mx-auto">
        
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 md:mb-20">
          

          <h2 
            data-r 
            style={{
              ...hide('up'),
              color: '#0F1C35',
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: 800,
              letterSpacing: '-0.02em'
            }}
            className="mb-6"
          >
            Event Gallery
          </h2>
          
         
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {/* {galleryImages.map((img, i) => (
            <button
              key={i}
              data-r
              style={hide('up')}
              onClick={() => openLightbox(i)}
              className="group relative aspect-[4/3] rounded-xl overflow-hidden cursor-pointer bg-gray-200 border border-black/5 shadow-sm hover:shadow-lg transition-all duration-300"
            >
              <img
                src={img.src}
                alt={img.caption}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
              />
              {/* Elegant dark gradient overlay on hover */}
              {/* <div className="absolute inset-0 bg-gradient-to-t from-[#0F1C35]/90 via-[#0F1C35]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-4">
                <span className="text-sm text-white font-bold tracking-wide opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-3 group-hover:translate-y-0 text-center">
                  {img.caption} */}
                {/* </span>
              </div>
            </button>
          ))} */} 
        </div>
        
      </div>
      <div className='flex items-center justify-center h-[60%] font-bold text-2xl'>
          <h2>Event Gallery is Coming Soon</h2>
        </div>

      {/* Lightbox Modal */}
      {activeIndex !== null && (
        <div
          className="fixed inset-0 z-[100] bg-[#0F1C35]/95 backdrop-blur-sm flex items-center justify-center p-4 md:p-8 transition-opacity"
          onClick={closeLightbox}
        >
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 md:top-8 md:right-8 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C9952A] text-white transition-colors duration-300 cursor-pointer z-10"
            aria-label="Close"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>

          {/* Previous Button */}
          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-4 md:left-8 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C9952A] text-white transition-colors duration-300 cursor-pointer z-10"
            aria-label="Previous"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Next Button */}
          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-4 md:right-8 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#C9952A] text-white transition-colors duration-300 cursor-pointer z-10"
            aria-label="Next"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* Image Container */}
          <div className="relative max-w-5xl w-full max-h-[85vh] flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
            <img
              src={galleryImages[activeIndex].src}
              alt={galleryImages[activeIndex].caption}
              className="max-w-full max-h-[80vh] rounded-lg object-contain shadow-2xl"
            />
            <p className="absolute -bottom-10 text-center text-white/90 text-sm md:text-base font-bold tracking-wide">
              {galleryImages[activeIndex].caption}
            </p>
            
            {/* Image Counter */}
            <div className="absolute -top-10 text-white/60 text-sm font-bold tracking-widest uppercase">
              {activeIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}